import styled from "styled-components";

export const CourierDetailBox = styled.div`
    display: flex;
    flex-direction: column;
    padding: 4px 0;
`;

export const CourierName = styled.div`
    font-weight: 500;
    font-size: 14px;
`;

export const CourierInfo = styled.div`
    font-size: 12px;
    color: #666;
    display: flex;
    gap: 16px;
`;

export const EquipmentSection = styled.div`
    margin-top: 12px;
`;

export const SelectedCouriersSection = styled.div`
    margin-bottom: 24px;
`;

export const SelectedCouriersTable = styled.div`
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    overflow: hidden;
`;

export const TableHeader = styled.div`
    display: grid;
    grid-template-columns: 2fr 2fr 3fr 80px;
    background-color: #fafafa;
    border-bottom: 1px solid #d9d9d9;
    font-weight: 600;
    padding: 12px 16px;
    gap: 8px;

    @media (max-width: 768px) {
        grid-template-columns: 1fr 1fr minmax(140px, 2fr) 56px;
    }
`;

export const TableRow = styled.div`
    display: grid;
    grid-template-columns: 2fr 2fr 3fr 80px;
    padding: 12px 16px;
    border-bottom: 1px solid #f0f0f0;
    align-items: center;
    gap: 8px;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background-color: #fafafa;
    }

    @media (max-width: 768px) {
        grid-template-columns: 1fr 1fr minmax(140px, 2fr) 56px;
    }
`;

export const CourierCell = styled.div`
    font-size: 14px;
`;

export const NoteCell = styled(CourierCell)`
    min-width: 0;

    .ant-input {
        width: 100%;
        min-width: 0;
    }

    @media (max-width: 768px) {
        min-width: 140px;
    }
`;

export const ActionCell = styled.div`
    display: flex;
    justify-content: flex-end;
`;
